import React, { useEffect, useRef } from "react";

function Stars({ containerId }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.innerHTML = "";
    for (let i = 0; i < 40; i++) {
      const s = document.createElement("div");
      const size = Math.random() * 2 + 0.5;
      s.style.cssText = `
        position:absolute;
        width:${size}px;height:${size}px;
        background:#fff;border-radius:50%;
        top:${Math.random() * 60}%;
        left:${Math.random() * 100}%;
        animation:twinkle ${2 + Math.random() * 3}s infinite;
        animation-delay:${Math.random() * 3}s;
      `;
      ref.current.appendChild(s);
    }
  }, []);

  return <div ref={ref} style={{ position: "absolute", inset: 0 }} />;
}

function ForestBackground() {
  return (
    <div className="vn-bg forest-bg">
      <Stars />
      <div className="forest-moon" />
      <div className="forest-mist" />

      {/* Arbres */}
      <div className="tree" style={{ left: "10px" }}>
        <div className="trunk" style={{ width: "8px", height: "50px" }} />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "60px",
            borderLeftWidth: "22px",
            borderRightWidth: "22px",
            bottom: "45px",
            borderBottomColor: "#0d2a10",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "50px",
            borderLeftWidth: "18px",
            borderRightWidth: "18px",
            bottom: "75px",
            borderBottomColor: "#0f3015",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "40px",
            borderLeftWidth: "14px",
            borderRightWidth: "14px",
            bottom: "100px",
            borderBottomColor: "#112e12",
          }}
        />
      </div>

      <div className="tree" style={{ left: "55px" }}>
        <div className="trunk" style={{ width: "10px", height: "65px" }} />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "75px",
            borderLeftWidth: "28px",
            borderRightWidth: "28px",
            bottom: "60px",
            borderBottomColor: "#0a2208",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "60px",
            borderLeftWidth: "22px",
            borderRightWidth: "22px",
            bottom: "95px",
            borderBottomColor: "#0d2a10",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "45px",
            borderLeftWidth: "16px",
            borderRightWidth: "16px",
            bottom: "128px",
            borderBottomColor: "#0f3015",
          }}
        />
      </div>

      <div className="tree" style={{ left: "120px" }}>
        <div className="trunk" style={{ width: "6px", height: "35px" }} />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "48px",
            borderLeftWidth: "18px",
            borderRightWidth: "18px",
            bottom: "31px",
            borderBottomColor: "#091e07",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "38px",
            borderLeftWidth: "14px",
            borderRightWidth: "14px",
            bottom: "57px",
            borderBottomColor: "#0b2409",
          }}
        />
      </div>

      <div className="tree" style={{ right: "70px" }}>
        <div className="trunk" style={{ width: "7px", height: "40px" }} />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "55px",
            borderLeftWidth: "20px",
            borderRightWidth: "20px",
            bottom: "36px",
            borderBottomColor: "#0a2208",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "44px",
            borderLeftWidth: "16px",
            borderRightWidth: "16px",
            bottom: "65px",
            borderBottomColor: "#0d2a10",
          }}
        />
      </div>

      <div className="tree" style={{ right: "20px" }}>
        <div className="trunk" style={{ width: "9px", height: "55px" }} />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "65px",
            borderLeftWidth: "25px",
            borderRightWidth: "25px",
            bottom: "50px",
            borderBottomColor: "#0b240a",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "55px",
            borderLeftWidth: "20px",
            borderRightWidth: "20px",
            bottom: "83px",
            borderBottomColor: "#0d2a0c",
          }}
        />
        <div
          className="treetop"
          style={{
            borderBottomWidth: "42px",
            borderLeftWidth: "15px",
            borderRightWidth: "15px",
            bottom: "112px",
            borderBottomColor: "#103010",
          }}
        />
      </div>

      <div className="forest-grass" />
      <div className="forest-ground" />
    </div>
  );
}

function CastleBackground() {
  return (
    <div className="vn-bg castle-bg">
      <Stars />
      <div className="castle-moon" />
      <div className="castle-fog" />

      {/* Structure château */}
      <div className="castle-wrap">
        {/* Tour gauche */}
        <div className="castle-tower tower-left">
          <div className="tower-cap" />
          <div className="tower-battlements">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="merlon" />
            ))}
          </div>
          <div className="castle-window" style={{ top: "30px" }} />
          <div className="castle-window" style={{ top: "70px" }} />
        </div>

        {/* Corps central */}
        <div className="castle-body">
          <div className="body-cap" />
          <div className="body-battlements">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="merlon" />
            ))}
          </div>
          <div
            className="castle-window"
            style={{ top: "15px", left: "20px" }}
          />
          <div
            className="castle-window"
            style={{ top: "15px", right: "20px" }}
          />
          <div className="castle-gate" />
        </div>

        {/* Tour droite */}
        <div className="castle-tower tower-right">
          <div className="tower-cap" />
          <div className="tower-battlements">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="merlon" />
            ))}
          </div>
          <div className="castle-window" style={{ top: "25px" }} />
          <div className="castle-window" style={{ top: "65px" }} />
        </div>
      </div>

      <div className="castle-ground" />
    </div>
  );
}

function Background({ type }) {
  return type === "castle" ? <CastleBackground /> : <ForestBackground />;
}

export default Background;
